import React, { useState } from 'react';
import { improveText } from '../api';

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  fieldKey?: string; // ex: 'objetivo.observacoes' ou 'experiencias.0.atividades'
  context?: any; // todo o currículo para gerar texto quando necessário
}

export default function TextWithAIButton({ value, onChange, placeholder, fieldKey, context }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleImprove = async () => {
    setError('');
    setLoading(true);
    try {
      const res = await improveText(value || '', fieldKey, context);
      if (res?.improvedText) {
        onChange(res.improvedText);
      } else {
        setError('IA não retornou texto');
      }
    } catch (e: any) {
      console.error(e);
      setError(e?.response?.data?.error || 'Erro ao melhorar texto');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-with-ai-btn">
      <textarea value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <button className="btn-ai" onClick={handleImprove} disabled={loading}>
          {loading ? '⏳' : 'Melhorar com IA'}
        </button>
        {error && <small style={{ color: 'red' }}>{error}</small>}
      </div>
    </div>
  );
}
